export default {
  code: 'default',
  name: '默认主题',
  description: '系统默认主题，适用于未配置自定义主题的租户',

  routeBase: '',  // 空字符串，直接放在 /:tenantCode 下

  routes: [
    { path: '', component: 'Promo', meta: { title: '首页' } },
    { path: 'gallery', component: 'Gallery', meta: { title: '作品展示' } },
    { path: 'work-submit', component: 'WorkSubmit', meta: { title: '提交作品' }, auth: true },
    { path: 'work/detail/:id', component: 'WorkDetail', meta: { title: '作品详情' } },
    { path: 'print-preview/:id', component: 'PrintPreview', meta: { title: '打印预览' }, auth: true },
    { path: 'user/center', component: 'UserCenter', meta: { title: '个人中心' }, auth: true },
    { path: 'my-works', component: 'MyWorks', meta: { title: '我的作品' }, auth: true },
    { path: 'login', component: 'Login', meta: { title: '登录' } },
    { path: 'register', component: 'Register', meta: { title: '注册' } }
  ],

  themeColor: '#409eff',
  secondaryColor: '#67c23a',

  apiPrefix: '/portal',

  extra: {
    organization: '',
    location: '',
    year: new Date().getFullYear(),
    contactEmail: '',
    activityPeriod: ''
  }
}
